import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MissingInputError } from '@shared/errors/missing-input/missing-input.error';
import { RECIPE_TRANSLATION_ICONS_PATH } from '@shared/constants/icons-paths.constant';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, UpperCasePipe } from '@angular/common';

export interface TranslationLang {
  source: string;
  target: string;
}

export interface SectionOptions {
  icon: string;
  title: string;
  lang?: TranslationLang;
}

@Component({
  selector: 'app-recipes-translation-section',
  templateUrl: './recipes-translation-section.component.html',
  styleUrls: ['./recipes-translation-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, TranslateModule, UpperCasePipe, NgIf],
})
export class RecipesTranslationSectionComponent implements OnInit {
  @Input() sectionOptions: SectionOptions;

  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);

  constructor() {
    this.loadSvgIcons();
  }

  ngOnInit(): void {
    if (!this.sectionOptions) {
      throw new MissingInputError('sectionOptions');
    }
  }

  private loadSvgIcons(): void {
    const iconNames = ['ic_actionable_dashboard_customize', 'ic_comment', 'ic_list', 'ic_title', 'icv_actionable_language'];
    const ICONS_FOLDER_PATH = `../../../../${RECIPE_TRANSLATION_ICONS_PATH}`;

    for (const iconName of iconNames) {
      this.matIconRegistry.addSvgIcon(iconName, this.domSanitizer.bypassSecurityTrustResourceUrl(`${ICONS_FOLDER_PATH}/${iconName}.svg`));
    }
  }
}
